var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-shell" }, [
    _c(
      "header",
      { staticClass: "app-shell__nav" },
      [_c("header-navigation-component")],
      1
    ),
    _c("main", { staticClass: "app-shell__main" }, [_c("child")], 1),
    _c(
      "footer",
      { staticClass: "app-shell__footer" },
      [_c("footer-component")],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }